// 封装方尔网络请求
import { getToken, updateTokenExpiresTime } from "@/utils/token";
import { ElNotification } from "element-plus";
import axios from "axios";
import qs from "qs";
import { getTipsMessage } from "./tipsDict";
import { succesMsg, alertBox } from "../msgBox";
import useAccountStore from "@/store/modules/account";

const notLoginUrlList = ["/ap-system/UserLogin"];
let Token_Err = false
export default class HttpRequest {
  constructor(baseUrl = "", timeout = 6000) {
    this.service = axios.create({
      baseURL: baseUrl,
      timeout: timeout,
    });

    this.setRequestInterceptors();
    this.setResponseInterceptors();
  }
  // 设置请求拦截器
  setRequestInterceptors() {
    // 请求连接器
    this.service.interceptors.request.use(
      (config) => {
        const token = getToken();
        if (token) {
          config.headers.Authorization = token; // 携带自定义token
        } else if (!notLoginUrlList.includes(config.url)) {
          location.href = "/";
        }
        // config.headers["Content-Type"] = "application/json";

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  // 设置响应拦截器
  setResponseInterceptors() {
    this.service.interceptors.response.use(
      (response) => {
        const data = response.data;
        // 判断请求是否成功或者为下载文件
        if (data.status === 1 || data?.type === "application/octet-stream") {
          updateTokenExpiresTime();
          return data;
        } else {
          return Promise.reject(data);
        }
      },
      (error) => {
        // 兼容blob下载出错json提示
        if (
          error.response.data instanceof Blob &&
          error.response.data.type.toLowerCase().indexOf("json") !== -1
        ) {
          const reader = new FileReader();
          reader.readAsText(error.response.data, "utf-8");
          reader.onload = function (e) {
            const errorMsg = JSON.parse(reader.result).message;
            ElNotification.error({
              title: errorMsg,
              duration: 5000,
            });
          };
        } else {
          let code = 0;
          try {
            code = error.response.data.status;
          } catch (e) {
            if (error.toString().indexOf("Error: timeout") !== -1) {
              ElNotification.error({
                title: "网络请求超时",
                duration: 5000,
              });
              return Promise.reject(error);
            }
          }
          if (code) {
            if (code === 401) {
              store.dispatch("LogOut").then(() => {
                // 用户登录界面提示
                Cookies.set("point", 401);
                location.reload();
              });
            } else if (code === 403) {
              router.push({ path: "/401" });
            } else {
              const errorMsg = error.response.data.message;
              if (errorMsg !== undefined) {
                ElNotification.error({
                  title: errorMsg,
                  duration: 5000,
                });
              }
              
            }
          } else {
            ElNotification.error({
              title: "接口请求失败",
              duration: 5000,
            });
          }
        }
        return Promise.reject(error);
      }
    );
  }

  _request(method = "POST", params = {}) {
    let { url, data, responseType, dataType, contentType } = params;

    // 请求头
    const headers = {};
    if (dataType) {
      headers["data-type"] = dataType;
    }
    if (contentType) {
      headers["content-type"] = contentType;
    }
    // 参数
    let dataParams = {};
    if (method === "GET") {
      dataParams = {
        params: params,
      };
    } else {
      dataParams = {
        data: qs.stringify(data, { skipNulls: true }), // qs 序列化数据 Content-Type:application/x-www-form-urlencoded
      };
    }

    return new Promise((resolve, reject) => {
      this.service
        .request({
          url: url,
          method: method,
          headers: headers,
          responseType: responseType ? responseType : "",
          ...dataParams,
        })
        .then((res) => {
          if (params.tips) {
            // 进行提示
            succesMsg(getTipsMessage(res.message));
          }
          resolve(res);
        })
        .catch((error) => {
          if(Token_Err){
            return
          }
          if(error.message === 'UN_LOGIN' || error.message === "TOKEN_OUT_TIME_EXCEPTION"){
            Token_Err = true
            alertBox("登录状态已过期，请重新登录", "确定", "warning").finally(
              () => {            
                useAccountStore()
                  .logOut(true)
                  .then(() => {
                    Token_Err = false
                    location.href = "/";
                  });
              }
            );
          }else{
            ElNotification({
              title: getTipsMessage(error.message),
              type: "error",
            });
            reject(error);
          }
          
        });
    });
  }

  axiosGet(params) {
    return this._request("GET", params);
  }

  axiosPost(params) {
    return this._request("POST", params);
  }

  /**
   * 导出文件
   * @param {*} params
   */
  axiosPostDownload(params) {
    this._request("POST", {
      ...params,
      responseType: "blob",
      dataType: "json",
      contentType: "application/x-www-form-urlencoded;charset=UTF-8",
    })
      .then((resData) => {
        this.downfiles(resData);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  /**
   * 下载文件
   * @param {*} data
   */
  downfiles(data) {
    let blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
    });
    let url = window.URL.createObjectURL(blob); // 创建一个临时 url 指向 blob 对象
    let a = document.createElement("a");
    a.href = url;
    a.download = new Date().getTime();
    a.click();
    // 释放这个临时的对象 url
    window.URL.revokeObjectURL(url);
  }
}
